module.exports = __webpack_public_path__ + "static/img/mdm_register3.2f2ebfb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/tip/mdm_register3.jpg
// module id = pWY0
// module chunks = 68